import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography, Toolbar } from '@material-ui/core';
// import ButtonWithDialog from './ButtonWithDialog';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(5),
    },
    table: {
        minWidth: 250,
    },
    toolbar: {
        justifyContent: 'space-between',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        [theme.breakpoints.up('sm')]: {
            minHeight: 37,
        },
    },
    title: {
        fontSize: '1.1rem',
    },
    row: {
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        },

        '&:hover': {
            backgroundColor: 'rgb(13, 39, 62, 0.25)',
        },
    },
    cell: {
        fontSize: '13px',
        paddingTop: 4,
        paddingBottom: 4,
        lineHeight: 2,

        '&:first-child': {
            borderRight: `1px solid rgba(224, 224, 224, 1);`,
            width: '30%',
            fontWeight: 'bold',
        },
    },
}));

export interface InfoTableProps {
    title: string;
    data: { [key: string]: { label: string; value: string; info?: string } };
    renderEditDialog?(toggleDialog: () => void): JSX.Element;
}

const InfoTable: React.FC<InfoTableProps> = ({ title, data, renderEditDialog }) => {
    const classes = useStyles();

    return (
        <>
            <TableContainer component={Paper} className={classes.root}>
                <Toolbar className={classes.toolbar}>
                    <Typography className={classes.title}>{title}</Typography>
                    {/* {renderEditDialog && <ButtonWithDialog>{renderEditDialog}</ButtonWithDialog>} */}
                </Toolbar>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                        {Object.values(data).map((field) => {
                            return (
                                <TableRow key={field.label} className={classes.row}>
                                    <TableCell component="th" scope="row" className={classes.cell}>
                                        {field.label}
                                    </TableCell>
                                    <TableCell className={classes.cell}>{field.info || field.value}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default InfoTable;
